import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

export default function ProductsProfessionalBuilder() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/buildercard.png"
          alt="Professional Builder"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          Professional Builder
        </div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          Professional Builder is the core of the boomLogic platform.
        </p>
        <p className="fs-5 ">
          It enables users to design, build and execute complex workflows
          directly, without relying on traditional development.
        </p>
        <p className="fs-5 ">
          Positioned as a no-code capability, it is accessible but not
          simplistic. It requires some understanding and time to become
          proficient, but once mastered, it provides a high degree of control
          and flexibility over how business processes are designed and run.
        </p>
        <p className="fs-5 ">
          At its core, Professional Builder allows organisations to take
          ownership of their operational workflows, removing dependency on long
          development cycles, costly third-party tools, or rigid legacy systems.
        </p>

        <p className="fs-5 fw-bold ">Key capabilities include:</p>
        <p>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Visual workflow design and orchestration
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Conditional logic and rule-based decisioning
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Integration with APIs, plugins and third-party systems
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Data ingestion, transformation, and routing
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Multi-channel communications embedded within workflows
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Event-driven triggers and automated process execution
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                SLA management and escalation handling
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Real-time monitoring and intervention
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Audit trails, logging and reporting
              </span>
            </span>
          </div>
          <div className="align-items-center gap-2">
            <span>
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">
                Reusable workflow components and templates
              </span>
            </span>
          </div>
        </p>

        <p className="fs-5 ">
          This enables the creation of highly tailored workflows that evolve
          with the business. There is no need to redevelop legacy systems,
          invest in single-purpose tools, or commit significant budget to
          processes that may quickly become outdated.
        </p>
        <p className="fs-5 ">
          With Boomerang, customers control the full lifecycle, build, test,
          deploy and iterate, while managing their data and integrations within
          a single platform.
        </p>
        <p className="fs-5 ">
          Changes can be made in real time, allowing processes to adapt quickly
          as requirements shift.
        </p>
        <p className="fs-5 ">
          <span className="fw-bold">The result is simple:</span> reduced risk,
          faster delivery, and the ability to continuously improve how the
          business operates without being constrained by technology.
        </p>
        <p className="fs-5 ">
          If existing solutions don’t quite fit, Professional Builder provides
          the flexibility to create exactly what’s needed. Our team can support
          delivery where required, or customers can take full ownership and
          develop their own capability within the platform.
        </p>
        <p className="fs-5 ">Professional Builder works in conjunction with:</p>
        <p>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/eventsAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Events</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/monitoringAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Monitoring</span>
            </a>
          </div>

          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/assetManagement"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Assets</span>
            </a>
          </div>

          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/apisPluginsandApps"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Integrations</span>
            </a>
          </div>
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
